import { CATEGORIES } from "./utils-app";

/**
 * Derive UI-facing intelligence meters (0-100) from an article when the
 * backend has not explicitly stored them. Keeps presentation consistent.
 */
export function articleMeters(a) {
  if (!a) return { legal: 0, business: 0, india: 0, odr: 0 };

  // Stored explicit meters (if backend ever sets them) take priority
  if (a.meters && typeof a.meters === "object") {
    return {
      legal: a.meters.legal ?? 70,
      business: a.meters.business ?? 60,
      india: a.meters.india ?? 50,
      odr: a.meters.odr ?? 40,
    };
  }

  const cat = (a.category || "").toLowerCase();
  const text = `${a.headline || ""} ${a.summary || ""} ${(a.tags || []).join(" ")}`.toLowerCase();

  let legal = 65, business = 55, india = 35, odr = 30;

  if (cat.includes("india")) { india = 92; business = 70; }
  if (cat.includes("odr") || cat.includes("digital") || cat.includes("ai in")) { odr = 88; }
  if (cat.includes("icsid") || cat.includes("investor")) { legal = 88; business = 75; }
  if (cat.includes("award") || cat.includes("set aside") || cat.includes("annulment")) { legal = 82; }
  if (cat.includes("institutional") || cat.includes("icc") || cat.includes("siac") || cat.includes("uncitral")) { legal = 72; business = 72; }
  if (cat.includes("explain")) { legal = 55; business = 60; }

  if (text.includes("india") || text.includes("delhi") || text.includes("mumbai") || text.includes("msme")) india = Math.max(india, 80);
  if (text.includes("odr") || text.includes("online") || text.includes("digital") || text.includes("virtual") || text.includes("ai")) odr = Math.max(odr, 70);
  if (text.includes("treaty") || text.includes("bit") || text.includes("annul")) legal = Math.max(legal, 85);
  if (text.includes("msme") || text.includes("commercial") || text.includes("business")) business = Math.max(business, 72);

  const clamp = (n) => Math.max(0, Math.min(100, Math.round(n)));
  return { legal: clamp(legal), business: clamp(business), india: clamp(india), odr: clamp(odr) };
}

/** Pick an AI confidence value consistently. */
export function articleConfidence(a) {
  if (!a) return 0;
  if (typeof a.ai_confidence === "number") return Math.round(a.ai_confidence * 100);
  return 94; // default for editorially-approved articles
}

/** Derive a region label from category or tags. */
export function articleRegion(a) {
  const cat = (a?.category || "").toLowerCase();
  if (cat.includes("india")) return "India";
  if (cat.includes("icc")) return "Global · ICC";
  if (cat.includes("icsid")) return "Global · ICSID";
  if (cat.includes("uncitral")) return "Global · UN";
  if (cat.includes("investor")) return "Global · ISDS";
  return "Global";
}

export const CATEGORY_EMOJI_MAP = {}; // intentionally empty — no emojis in UI
export { CATEGORIES };
